import MenuGroup from "./MenuGroup";
import Menu from "./Menu";
import AssignedMenu from "./AssignedMenu";
import { Tabs } from "antd";
import getMenuInfo from "controllers/getMenuInfo";
import {
  refreshMenuGroupAction,
  refreshMenuAction,
  assignedMenuAction,
} from "hooks/actions/etcAction";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import { useEffect } from "react";

function AdminSetting() {
  const dispatch = useDispatch();

  useEffect(() => {
    getMenuInfo
      .menuGroupList()
      .then((data) => {
        if (data.response && data.response.status === 401) {
          dispatch(authAction(false, null));
        } else {
          dispatch(refreshMenuGroupAction(data));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dispatch]);
  useEffect(() => {
    getMenuInfo
      .menuList()
      .then((data) => {
        if (data.response && data.response.status === 401) {
          dispatch(authAction(false, null));
        } else {
          dispatch(refreshMenuAction(data));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dispatch]);
  useEffect(() => {
    getMenuInfo
      .getAssignedMenu()
      .then((data) => {
        dispatch(assignedMenuAction(data));
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dispatch]);

  const items = [
    { label: "관리영역", key: "item-1", style:{height:"100%"}, children: <MenuGroup /> }, // remember to pass the key prop
    { label: "관리메뉴", key: "item-2", style:{height:"100%"}, children: <Menu /> },
    { label: "범위설정", key: "item-3", style:{height:"100%"}, children: <AssignedMenu /> },
  ];

  return (
    <div style={{width:"100%", height:"100%"}}>
      <Tabs defaultActiveKey="item-1" type="card" size="middle" items={items} style={{width:"100%", height:"100%"}}/>
    </div>
  );
}

export default AdminSetting;
